"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.processing.done': 'Done',
    'avatar.processing.is_processing': 'Processing',
};
